import { memo as Memo } from 'react'

//* Components
import Container from 'components/common/Container'
import Text from 'components/common/Text'
import FullVideoImage from 'components/common/FullVideoImage'
import CardsEffectSlider from 'components/common/CardsEffectSlider'

//* Styles
import CardsEffectSliderGalleryStyle from './style'

const CardsEffectSliderGallery = Memo(({ first, title, images, description, file }) => {
	return (
		<CardsEffectSliderGalleryStyle>
			<Container first={first} section>
				<Container>
					<Text text={title} tag={first ? 'h1' : 'h2'} className={`font-soundscape h2 cesg-title`} />
				</Container>

				<CardsEffectSlider images={images} />

				<Container>
					<Text text={description} tag={'h3'} className={`font-ping h4 cesg-description`} />
				</Container>
			</Container>

			{file?.url && (
				<Container className='cesg-full-image-container' full section>
					<FullVideoImage file={file} alt={file?.alt} />
				</Container>
			)}
		</CardsEffectSliderGalleryStyle>
	)
})

export default CardsEffectSliderGallery
